import { useCallback } from 'react';
import { useQuery, UseQueryResult } from 'react-query';
import { SystemActivitiesResponse, PartialActivityLogSearchQuery } from '../@types/Audit';
import { useAxios } from '../context/AxiosContext';

export function useSystemActivities(
  query: PartialActivityLogSearchQuery
): UseQueryResult<SystemActivitiesResponse, unknown> {
  const { authAxios } = useAxios();

  const fetchActivities = useCallback(
    async (query: PartialActivityLogSearchQuery) => {
      const response = await authAxios.get<SystemActivitiesResponse>('/audit/system', {
        params: query
      });
      return response.data;
    },
    [authAxios]
  );
  return useQuery<SystemActivitiesResponse>(['system-activities', query], () => fetchActivities(query), {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: !!query.type,
    initialData: { records: [], totalPages: 0 }
  });
}
